var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionManager({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.92993 15.8799L15.8799 3.92993M11.1009 18.2799L12.3009 17.0799M13.7929 15.5889L16.1829 13.1989",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00003 21.998H22M3.60103 10.239L10.241 3.599C12.361 1.479 13.421 1.469 15.521 3.569L20.431 8.479C22.531 10.579 22.521 11.639 20.401 13.759L13.761 20.399C11.641 22.519 10.581 22.529 8.48103 20.429L3.57103 15.519C1.47103 13.419 1.47103 12.369 3.60103 10.239Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionManager);
export default __webpack_public_path__ + "static/media/subscription_manager.6bcbdee06d4f9379f067379a50551e50.svg";
export { ForwardRef as ReactComponent };